import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Match, ScorerStanding } from '../../models/match';
import { PlayerRegistryEntry, Team } from '../../models/team';
import { GroupStandings, TournamentGroup } from '../../models/tournament';
import { MatchService } from '../../services/match.service';
import { PlayerRegistryService } from '../../services/player-registry.service';
import { TeamService } from '../../services/team.service';
import { TournamentService } from '../../services/tournament.service';
import { AdminRole, AuthService } from '../../services/auth.service';
import { SystemStatusService } from '../../services/system-status.service';

@Component({
  standalone: false,
  selector: 'app-admin',
  template: "<app-loading-overlay [show]=\"isLoading || isBulkActionRunning || isPublicStatusSaving\"></app-loading-overlay>\n\n<section class=\"admin-intro\">\n  <div>\n    <p class=\"eyebrow\">Pannello amministrativo</p>\n    <h2>ScipioneCup</h2>\n  </div>\n  <a routerLink=\"/\" target=\"_blank\" rel=\"noreferrer\">Apri schermo pubblico</a>\n</section>\n\n<p class=\"error-message\" *ngIf=\"errorMessage\">{{ errorMessage }}</p>\n<p class=\"success-message\" *ngIf=\"successMessage\">{{ successMessage }}</p>\n<p class=\"loading-message\" *ngIf=\"isBulkActionRunning || isPublicStatusSaving\">Operazione in corso, attendere...</p>\n\n<div class=\"grid\">\n  <section class=\"card system-status-card\" *ngIf=\"canUseMassiveActions()\">\n    <div class=\"section-heading\">\n      <div>\n        <h2>Sistema pubblico</h2>\n        <p class=\"hint\">{{ publicOffline ? 'Offline: il pubblico vede la pagina coming soon.' : 'Online: il pubblico vede live, news e classifiche.' }}</p>\n      </div>\n      <button type=\"button\" [class.danger]=\"!publicOffline\" [class.secondary]=\"publicOffline\" (click)=\"togglePublicOffline()\" [disabled]=\"isPublicStatusSaving\">\n        {{ isPublicStatusSaving ? 'Salvataggio...' : (publicOffline ? 'Riattiva pubblico' : 'Metti offline') }}\n      </button>\n    </div>\n  </section>\n\n  <details class=\"card accordion-card maintenance-card\" *ngIf=\"canUseMassiveActions()\">\n    <summary>\n      <span>Operazioni massive</span>\n      <small>Azzeramenti e cancellazioni</small>\n    </summary>\n    <div class=\"accordion-body bulk-actions\">\n      <button type=\"button\" class=\"secondary\" (click)=\"resetAllMatches()\" [disabled]=\"isBulkActionRunning\">Azzera tutte le partite</button>\n      <button type=\"button\" class=\"danger\" (click)=\"deleteGroupMatches()\" [disabled]=\"isBulkActionRunning\">Cancella partite gironi</button>\n      <button type=\"button\" class=\"danger\" (click)=\"deleteKnockoutMatches()\" [disabled]=\"isBulkActionRunning\">Cancella fase finale</button>\n      <button type=\"button\" class=\"danger\" (click)=\"deleteAllGroups()\" [disabled]=\"isBulkActionRunning\">Cancella tutti i gironi</button>\n      <button type=\"button\" class=\"danger\" (click)=\"deleteAllTeams()\" [disabled]=\"isBulkActionRunning\">Cancella tutte le squadre</button>\n      <button type=\"button\" class=\"danger\" (click)=\"deleteAllPlayerRegistry()\" [disabled]=\"isBulkActionRunning\">Cancella anagrafiche giocatori</button>\n    </div>\n  </details>\n\n  <app-team-admin *ngIf=\"canManageTournament()\" [teams]=\"teams\" [registryPlayers]=\"players\" (changed)=\"refresh()\"></app-team-admin>\n  <app-group-admin *ngIf=\"canManageTournament()\" [teams]=\"teams\" [groups]=\"groups\" (changed)=\"refresh()\"></app-group-admin>\n  <app-match-admin [teams]=\"teams\" [groups]=\"groups\" [matches]=\"matches\" [role]=\"role\" (changed)=\"refresh()\"></app-match-admin>\n  <app-live-admin [liveMatch]=\"liveMatch\" [teams]=\"teams\" (changed)=\"refresh()\"></app-live-admin>\n  <app-news-admin></app-news-admin>\n  <app-standings-admin\n    [standings]=\"standings\"\n    [scorers]=\"scorers\"\n    [canGenerateKnockout]=\"canManageTournament()\"\n    (changed)=\"refresh()\"\n  ></app-standings-admin>\n  <app-knockout-admin *ngIf=\"canManageTournament()\" [matches]=\"knockoutMatches\"></app-knockout-admin>\n</div>\n",
  styles: [".admin-intro {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.admin-intro h2 {\n  font-size: 2rem;\n  margin: 0;\n}\n\n.admin-intro a {\n  background: linear-gradient(135deg, #ffd000, #eda900);\n  border-radius: 12px;\n  color: #080808;\n  font-weight: 700;\n  padding: 0.75rem 1rem;\n  text-decoration: none;\n}\n\n.eyebrow {\n  color: #20db60;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin: 0 0 0.25rem;\n  text-transform: uppercase;\n}\n\n.grid {\n  display: grid;\n  gap: 1.25rem;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.3fr);\n}\n\n.admin-page-grid {\n  display: grid;\n  gap: 1.25rem;\n  grid-template-columns: minmax(0, 1fr);\n}\n\napp-live-admin {\n  grid-column: 1 / -1;\n}\n\n.maintenance-card,\napp-standings-admin,\napp-knockout-admin {\n  grid-column: 1 / -1;\n}\n\n.error-message {\n  background: rgba(220, 38, 38, 0.16);\n  border: 1px solid rgba(248, 113, 113, 0.4);\n  border-radius: 8px;\n  color: #fecaca;\n  padding: 0.9rem 1rem;\n}\n\n.success-message {\n  background: rgba(34, 197, 94, 0.16);\n  border: 1px solid rgba(74, 222, 128, 0.35);\n  border-radius: 8px;\n  color: #bbf7d0;\n  padding: 0.9rem 1rem;\n}\n\n.bulk-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n@media (max-width: 960px) {\n  .admin-intro {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n"]
})
export class AdminComponent implements OnInit {
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly teamService = new TeamService();
  private readonly playerRegistryService = new PlayerRegistryService();
  private readonly matchService = new MatchService();
  private readonly tournamentService = new TournamentService();
  private readonly authService = new AuthService();
  private readonly systemStatusService = new SystemStatusService();

  role: AdminRole | null = null;
  publicOffline = false;
  teams: Team[] = [];
  players: PlayerRegistryEntry[] = [];
  matches: Match[] = [];
  groups: TournamentGroup[] = [];
  standings: GroupStandings[] = [];
  scorers: ScorerStanding[] = [];
  knockoutMatches: Match[] = [];
  liveMatch: Match | null = null;
  errorMessage = '';
  successMessage = '';
  isLoading = true;
  isBulkActionRunning = false;
  isPublicStatusSaving = false;

  ngOnInit(): void {
    this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      this.isLoading = true;
      this.changeDetector.detectChanges();
      const [authState, systemStatus, teams, players, matches, groups, standings, scorers, knockoutMatches, liveMatch] = await Promise.all([
        this.authService.me(),
        this.systemStatusService.get(),
        this.teamService.list(),
        this.playerRegistryService.list(),
        this.matchService.list(),
        this.tournamentService.listGroups(),
        this.tournamentService.standings(),
        this.matchService.scorers(),
        this.tournamentService.knockout(),
        this.matchService.live()
      ]);

      this.role = authState.role ?? null;
      this.publicOffline = Boolean(systemStatus.public_offline);
      this.teams = teams;
      this.players = players;
      this.matches = matches;
      this.groups = groups;
      this.standings = standings;
      this.scorers = scorers;
      this.knockoutMatches = knockoutMatches;
      this.liveMatch = liveMatch;
      this.errorMessage = '';
    } catch (error) {
      this.errorMessage = 'Errore durante il caricamento dei dati.';
      console.error(error);
    } finally {
      this.isLoading = false;
      this.changeDetector.detectChanges();
    }
  }

  async resetAllMatches(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi azzeramento di risultati, stato e data di tutte le partite?')) {
      return;
    }
    await this.runBulkAction(() => this.matchService.resetAll(), 'Tutte le partite sono state azzerate.');
  }

  async deleteGroupMatches(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi la cancellazione di tutte le partite dei gironi?')) {
      return;
    }
    await this.runBulkAction(() => this.matchService.deleteGroupMatches(), 'Tutte le partite dei gironi sono state cancellate.');
  }

  async deleteKnockoutMatches(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi la cancellazione di tutte le partite della fase finale?')) {
      return;
    }
    await this.runBulkAction(() => this.matchService.deleteKnockoutMatches(), 'Tutte le partite della fase finale sono state cancellate.');
  }

  async deleteAllGroups(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi la cancellazione di tutti i gironi? L\'operazione riesce solo se non ci sono partite.')) {
      return;
    }
    await this.runBulkAction(() => this.tournamentService.deleteAllGroups(), 'Tutti i gironi sono stati cancellati.');
  }

  async deleteAllTeams(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi la cancellazione di tutte le squadre? L\'operazione riesce solo se non ci sono partite e gironi.')) {
      return;
    }
    await this.runBulkAction(() => this.teamService.deleteAll(), 'Tutte le squadre sono state cancellate.');
  }

  async deleteAllPlayerRegistry(): Promise<void> {
    if (this.isBulkActionRunning) {
      return;
    }

    if (!window.confirm('Confermi la cancellazione di tutte le anagrafiche giocatori? L operazione riesce solo se non ci sono giocatori associati alle squadre.')) {
      return;
    }
    await this.runBulkAction(() => this.playerRegistryService.deleteAll(), 'Tutte le anagrafiche giocatori sono state cancellate.');
  }

  async togglePublicOffline(): Promise<void> {
    if (this.isPublicStatusSaving) {
      return;
    }

    if (!this.canUseMassiveActions()) {
      return;
    }

    const nextState = !this.publicOffline;
    const message = nextState
      ? 'Confermi di mettere offline il sistema pubblico? Solo il super user potra accedere all area admin.'
      : 'Confermi di riattivare il sistema pubblico?';
    if (!window.confirm(message)) {
      return;
    }

    try {
      this.isPublicStatusSaving = true;
      this.successMessage = '';
      this.errorMessage = '';
      const status = await this.systemStatusService.update(nextState);
      this.publicOffline = Boolean(status.public_offline);
      this.successMessage = this.publicOffline ? 'Operazione conclusa. Sistema pubblico offline.' : 'Operazione conclusa. Sistema pubblico online.';
      this.errorMessage = '';
      this.changeDetector.detectChanges();
    } catch (error) {
      this.successMessage = '';
      this.errorMessage = error instanceof Error ? error.message : 'Errore durante l aggiornamento dello stato pubblico.';
      this.changeDetector.detectChanges();
    } finally {
      this.isPublicStatusSaving = false;
      this.changeDetector.detectChanges();
    }
  }

  canUseMassiveActions(): boolean {
    return this.role === 'super_user';
  }

  canManageTournament(): boolean {
    return this.role === 'super_user' || this.role === 'organizzatore';
  }

  private async runBulkAction(action: () => Promise<void>, successMessage: string): Promise<void> {
    try {
      this.isBulkActionRunning = true;
      this.successMessage = '';
      this.errorMessage = '';
      await action();
      this.successMessage = `Operazione conclusa. ${successMessage}`;
      this.errorMessage = '';
      await this.refresh();
    } catch (error) {
      this.successMessage = '';
      this.errorMessage = error instanceof Error ? error.message : 'Errore durante l\'operazione massiva.';
      this.changeDetector.detectChanges();
    } finally {
      this.isBulkActionRunning = false;
      this.changeDetector.detectChanges();
    }
  }
}
